module.exports = __webpack_public_path__ + "img/product_132.65b5f82.svg";